module.exports = __webpack_public_path__ + "static/media/Targeting.b4ce77b2.svg";